// ENV value productions or development is set in package.json.
// Udpate version in this file before deploymet tuo make sure that js and css files are reloaded.
// --dist-dir setting for parcel build and watch in package.json
module.exports = {
    version: 122,
    environment: process.env.ENV,
    development: {
        client : "http://localhost:3000",
        server : "http://localhost:8080",
        console : "http://localhost:3000",
        rootPath : "",
        staticFilesRootPath : ""
    },
    production: {
        client : "",
        server : "",
        console : "/console",
        rootPath : "",
        staticFilesRootPath : "/web2020",
    },
    browserSyncStartPath : "/fi/"
};